import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(loc.hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { nav("/login"); return; }
    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id });
        setToken(r.data.token);
        setUser(r.data.user);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [loc.hash, nav, setUser]);

  return <div className="min-h-screen flex items-center justify-center text-[color:var(--text-secondary)]">Signing you in...</div>;
}
